import Button from '@admin/components/button'
import PropTypes from 'prop-types'
import React from 'react'

class Reply extends React.PureComponent {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    reply: PropTypes.object,
    onRemove: PropTypes.func
  }

  render() {
    const { reply, onRemove } = this.props
    return (
      <div className="campaigns-social-conversations-post-comment-reply">
        <div className="campaigns-social-conversations-post-comment-reply-username">
          { reply.user_name || 'Unknown' }
        </div>
        <div className="campaigns-social-conversations-post-comment-reply-text">
          <div dangerouslySetInnerHTML={{ __html: reply.text.replace('\n', '<br />') }} />
        </div>
        { onRemove &&
          <Button { ...this._getRemove() } />
        }
      </div>
    )
  }

  _getRemove() {
    const { onRemove } = this.props
    return {
      svg: 'x',
      className: 'campaigns-social-conversations-post-comment-reply-action',
      handler: onRemove
    }
  }

}

export default Reply
